import { Canvas } from '@react-three/fiber';
import React, { Suspense } from 'react';
import Pegasus from './Pegasus';

interface Props {
  expression?: string;
}

const camera = { fov: 50, position: [10, 10, 10] };
const position = [300, 300, 4000];

const PegasusAvatar = ({ expression }: Props) => (
  <Canvas camera={camera}>
    <Suspense fallback={null}>
      <ambientLight intensity={0.3} />
      <spotLight intensity={0.5} position={position} />
      <Pegasus expression={expression} />
    </Suspense>
  </Canvas>
);

export default PegasusAvatar;
